import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconRobot } from "@arco-design/web-vue/es/icon";

const routes: AppRouteRecordRaw = {
  path: '/assistant',
  redirect: '/assistant/channel/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: 'AI 助手',
    icon: IconRobot,
    order: 1300,
    roles: ['assistanteer'],
  },
  children: [
    {
      path: 'channel/index',
      component: () => import('@/views/assistant/channel/index.vue'),
      meta: {
        title: '渠道管理',
      },
    },
    {
      path: 'channel/add',
      component: () => import('@/views/assistant/channel/add-edit.vue'),
      meta: {
        title: '新增渠道',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/assistant/channel/index',
      },
    },
    {
      path: 'channel/edit/:id',
      component: () => import('@/views/assistant/channel/add-edit.vue'),
      props: true,
      meta: {
        title: '修改渠道',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/assistant/channel/index',
      },
    },
  ],
};

export default routes;
